import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { get } from "../../../../utils/api";
import MultiColumns from "../MultiColumns";

import { companyId } from "../../../../utils/companyId";

const Wellbeing = ({ isEditing }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `/social/employee_well_being_development/${companyId}`
        );
        // Update state only if data is available
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const questionary = [
    {
      key: "employeeAtStartofYear",
      question: "Employees at the start of year",
    },
    {
      key: "employeeAtEndofYear",
      question: "Employees at the end of year",
    },
    {
      key: "employeeLeftDuringYear",
      question: "Employees left during the year",
    },
    {
      key: "turnoverRate.value",
      key2: "turnoverRate.unit",
      question: "Turnover Rate",
    },
    {
      key: "trainingHoursPerEmployee.value",
      key2: "trainingHoursPerEmployee.unit",
      question: "Training Hours per Employee",
    },
    {
      key: "totalWorkingHours",
      question: "Total working hours in the year",
    },
    {
      key: "numberOfInjuries",
      question: "Number of lost time injuries (LTI) during the year",
    },
    {
      key: "employeeHealthAndSafety.value",
      question: "Lost time injury frequency rate (LTIFR)",
    },
  ];

  return (
    <>
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          fontFamily: "inter",
          textTransform: "uppercase",
          mt: "10px",
          color: "#EB7E0E",
        }}
      >
        Baseline : Social
      </Typography>
      <MultiColumns
        title="EMPLOYEE WELL BEING and development"
        url={`/social/employee-development`}
        questionary={questionary}
        columns={3}
        data={data}
        isEditing={isEditing}
      />
    </>
  );
};

export default Wellbeing;
